import { render, staticRenderFns } from "./WidgetCreatorFirstStep.vue?vue&type=template&id=490fa100&scoped=true&"
import script from "./WidgetCreatorFirstStep.vue?vue&type=script&lang=js&"
export * from "./WidgetCreatorFirstStep.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCreatorFirstStep.vue?vue&type=style&index=0&id=490fa100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490fa100",
  null
  
)

export default component.exports